import { Button } from '../Button';
import { FC } from 'react';
import { Box } from 'ui/Box';

export interface ButtonsSetProps {
  onBack: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  className?: string;
}

export const ButtonsSet: FC<ButtonsSetProps> = ({
  onBack,
  onNext,
  isNextDisabled,
  className = '',
}) => {
  const boxStyle = `min-w-min flex items-center mt-9 gap-4 sm:max-w-60 w-full ${className}`;

  return (
    <Box className={boxStyle}>
      <Button variant="back" onClick={onBack} />
      <Button variant="next" onClick={onNext} disabled={isNextDisabled} />
    </Box>
  );
};
